// extracted by mini-css-extract-plugin
export default {"slide":"index_slide_vyIIn","dot":"index_dot_IZIkG","current":"index_current_XmD9G"};